import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useForm } from "react-hook-form";
import { useCallback } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";

import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ContasRecebimentoForm, ContasRecebimentoSchema, defaultContasRecebimentoForm } from "../../../schemas/ContasReceber_lista/ContasReceber_recebimento";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";

/**
 * CadastroRecebimentoModal
 */

type Props = {
  open: boolean,
  saving: boolean,
  valorTotalRecebido: number,
  ddlBanco: DropDown[],
  onSubmit: (form: ContasRecebimentoForm) => void,
  onClose: () => void,

};

export const CadastroRecebimentoModal = ({
  open,
  saving,
  valorTotalRecebido,
  ddlBanco,
  onSubmit,
  onClose,

}: Props) => {

  const hookFormRecebimento = useForm<ContasRecebimentoForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    defaultValues: defaultContasRecebimentoForm,
    resolver: zodResolver(ContasRecebimentoSchema),

  });


  const handleSubmit = useCallback((form: ContasRecebimentoForm) => {
    if (!saving) onSubmit(form);

  }, [saving, onSubmit]);

  const handleClose = useCallback(() => {
    if (!saving) onClose();

  }, [saving, onClose]);

  return (

    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookFormRecebimento.handleSubmit(handleSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>

      <DialogTitle>
        Receber Contas
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>

              <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
                <div className="mb-2 mt-2 m-2 max-w-[200px]">
                  <FormDatePickerInput
                    name='dataRecebimento'
                    label='Data á Receber'
                    required={true}
                    reactHookForm={hookFormRecebimento} />
                </div>

                <div className="mb-2 mt-2">
                  <span className="text-sm font-medium text-gray-900 dark:text-white">
                    Valor Recebido: R$ {valorTotalRecebido.toFixed(2)}
                  </span>
                </div>

              </div>

              <div className="w-full">
                <DefaultFormAutocomplete
                  name='idBancoPagamento'
                  label='Banco de Recebimento'
                  required={false}
                  readOnly={saving}
                  options={ddlBanco}
                  getOptionLabel={(x) => x.title}
                  getOptionKey={(x) => x.id}
                  reactHookForm={hookFormRecebimento} />
              </div>

              <DefaultFormInput
                name='formaRecebimento'
                label='Forma de Recebimento'
                readOnly={saving}
                multiline={true}
                rows={2}
                reactHookForm={hookFormRecebimento}
              />

              <DefaultFormInput
                name='nroNotaFiscal'
                label='Nº Nota Fiscal'
                readOnly={saving}
                multiline={true}
                rows={2}
                reactHookForm={hookFormRecebimento}
              />

              <DefaultFormInput
                name='nroDocumento'
                label='Nº Documento '
                readOnly={saving}
                multiline={true}
                rows={2}
                reactHookForm={hookFormRecebimento}
              />

              <DefaultFormInput
                name='observacao'
                label='Observações'
                readOnly={saving}
                multiline={true}
                rows={5}
                reactHookForm={hookFormRecebimento}
              />

            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}